/**
 * Everything whose cached value the Art. 5 benefit declaration changes.
 *
 * This exists as a named set rather than as two `invalidateQueries` calls at
 * the save site because the bug it fixes was exactly one of the two being
 * absent. On 2026-10-07 an accountant saved the declaration for TECHERA NUÑEZ
 * and the Literal E card went on showing UYU 514 — the declaration query was
 * invalidated, the PLANS query was not, and nothing else in the portal ever
 * invalidates that key. He read the stale 514 as "no me deja continuar sin
 * pagar" and only got unstuck when confirming an unrelated step happened to
 * force a refetch.
 *
 * The price is downstream of the declaration: `fiscalBenefitFlowFor` turns a
 * complies + motivo='iva_minimo' declaration into 'provider_discount', which is
 * what makes `resolveTenantPlanCharge` subtract the 80 UI credit (514 in 2026)
 * from the 514 list price and land on exactly 0. So the moment the declaration
 * is written, any plan price already on screen is wrong.
 *
 * Add to this list rather than to the call site when something else starts
 * depending on the declaration.
 */
export function queryKeysInvalidatedByBenefitDeclaration(
  tenantId: string,
): readonly unknown[][] {
  return [
    // The declaration itself — what the régimen step reads back to render done.
    ['accountant-fiscal-benefit-declaration', tenantId],
    // The prices. Literal E is 514 without the declaration and 0 with it, and
    // that difference is the entire user-visible bug this module exists for.
    ['tenants', 'current', 'plans', tenantId],
  ];
}
